

import ClientHead from "@/components/main/core/ClientHead";
import RedSection from "@/components/main/core/RedSection";
import GreySection from "@/components/main/core/GreySection";
import CheckBox from "@/components/main/core/CheckBox";
import SingUpForm from "@/components/main/forms/SingUpForm";
import FormButton from "@/components/main/buttons/FormButton";

import sara from "@/assets/images/landing/img/sara-ava.png";
import judi from "@/assets/images/landing/img/Judi.png";
import jessica from "@/assets/images/landing/img/Jessica-ava.png";

import american from "@/assets/images/landing/svg/flag-american.svg";
import canada from "@/assets/images/landing/svg/flag-canada.svg";

import data from "@/mixins/data"
export default {

  head() {
    const title = 'Discover If Your Partner Has A Hidden Dating Profile | iFindCheaters';
    const description = 'Find your cheating spouse &#128148; and partner husband, wife or partner\'s hidden online dating profile anonymously by email and name on all popular dating sites and apps all over the world. &#9989; Catch online cheaters in a few clicks now!'

    return {
      title: title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex'
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
    }
  },

  name: "register",
  layout: 'clientLayout',
  mixins: [data],
  components: { ClientHead, SingUpForm,  FormButton,  RedSection, CheckBox, GreySection },
  data() {
    return {
      comments: [
        {
          name: 'sara1974',
          img: sara,
          flag: american,
          text: 'Social media, when I was younger, used to make or break relationships. Nowadays, SM seems to be a tether that help keep relationships strong. Sometimes we need make time to put the technology away and focus on our relationships. With just a couple of clicks, I can protect myself now. Thanks'
        },
        {
          name: 'JudyAngel82',
          img: judi,
          flag: american,
          text: 'I had been hurt by people a lot and that made me very cautious in a point that I closed everyone out and believe that I’m just going to be alone. In that moment something strange happen I found a person that manage to give me hope. I realized the moment I stopped caring I stopped judging overthinking and I managed to actually open up. But now I can get the info that kept me from making a big mistake'
        },
        {
          name: 'Jessica1144',
          img: jessica,
          flag: canada,
          text: 'Glad I used this site, got the info I needed. best website to find cheaters'
        }
      ]
    }
  },
  computed: {},
  mounted() {
    // this.showNotify()
  },
  methods: {
    showNotify(msg) {
      this.$notify({
        group: 'main',
        title: 'Error',
        text: `${msg}`,
        type: 'error',
        speed: 1000,
        duration: 10000,
      });
    }
  },
}
